import { render, staticRenderFns } from "./CierreDetalle.vue?vue&type=template&id=6cfbc37a&scoped=true"
import script from "./CierreDetalle.vue?vue&type=script&lang=js"
export * from "./CierreDetalle.vue?vue&type=script&lang=js"
import style0 from "./CierreDetalle.vue?vue&type=style&index=0&id=6cfbc37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbc37a",
  null
  
)

export default component.exports